import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useApp } from "@/contexts/AppContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { Plus, Trash2, BookOpen } from "lucide-react";

export default function PlanContable() {
  const { empresa, formatApiError } = useApp();
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const blank = { codigo: "", nombre: "", nivel: 2, naturaleza: "DEUDORA" };
  const [form, setForm] = useState(blank);

  const load = async () => { const { data } = await api.get("/plan-contable"); setItems(data); };
  useEffect(() => { if (empresa) load(); /* eslint-disable-next-line */ }, [empresa]);

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/plan-contable", { ...form, nivel: +form.nivel }); toast.success("Cuenta creada"); setOpen(false); setForm(blank); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const eliminar = async (c) => { if (!confirm("¿Eliminar?")) return; await api.delete(`/plan-contable/${c.id}`); toast.success("Eliminada"); load(); };

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight text-slate-900">Plan Contable (PCGE)</h1>
          <p className="text-[13px] text-slate-500">Plan Contable General Empresarial. Cuentas predefinidas y personalizables.</p>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button className="h-9 bg-slate-900 text-white"><Plus className="w-4 h-4 mr-1" /> Nueva cuenta</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Nueva cuenta contable</DialogTitle></DialogHeader>
            <form onSubmit={submit} className="space-y-3 text-sm">
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <Label className="text-[12px]">Código</Label>
                  <Input value={form.codigo} onChange={(e) => setForm({ ...form, codigo: e.target.value })} required className="h-9 mono" />
                </div>
                <div>
                  <Label className="text-[12px]">Nivel</Label>
                  <Input type="number" min="1" max="5" value={form.nivel} onChange={(e) => setForm({ ...form, nivel: e.target.value })} className="h-9" />
                </div>
              </div>
              <div>
                <Label className="text-[12px]">Nombre</Label>
                <Input value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} required className="h-9" />
              </div>
              <div>
                <Label className="text-[12px]">Naturaleza</Label>
                <Select value={form.naturaleza} onValueChange={(v) => setForm({ ...form, naturaleza: v })}>
                  <SelectTrigger className="h-9"><SelectValue /></SelectTrigger>
                  <SelectContent><SelectItem value="DEUDORA">Deudora</SelectItem><SelectItem value="ACREEDORA">Acreedora</SelectItem></SelectContent>
                </Select>
              </div>
              <DialogFooter><Button type="submit" className="bg-slate-900 text-white">Guardar</Button></DialogFooter>
            </form>
          </DialogContent>
        </Dialog>
      </div>

      <div className="bg-white border border-slate-200 rounded-md">
        <table className="tbl w-full">
          <thead><tr><th>Código</th><th>Nombre</th><th>Nivel</th><th>Naturaleza</th><th>Sistema</th><th></th></tr></thead>
          <tbody>
            {items.length === 0 ? <tr><td colSpan={6} className="text-center py-6 text-slate-500"><BookOpen className="w-8 h-8 mx-auto mb-2 text-slate-300" />Cargando plan contable...</td></tr>
              : items.map((c) => (
                <tr key={c.id}>
                  <td className="mono font-bold text-slate-900">{c.codigo}</td>
                  <td className="text-slate-700" style={{ paddingLeft: `${(c.nivel - 1) * 16 + 12}px` }}>{c.nombre}</td>
                  <td className="mono">{c.nivel}</td>
                  <td><span className={c.naturaleza === "DEUDORA" ? "badge badge-info" : "badge badge-warning"}>{c.naturaleza}</span></td>
                  <td>{c.system ? <span className="badge badge-muted">SISTEMA</span> : <span className="badge badge-success">PERSONAL</span>}</td>
                  <td className="text-right">{!c.system && <button onClick={() => eliminar(c)} className="text-slate-600 hover:text-rose-600"><Trash2 className="w-4 h-4" /></button>}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
